module.exports = __webpack_public_path__ + "08c2ae708c7c469992a24d30f80d5495.pdf";